/*
 * @Author: lyx
 * @Date: 2024-06-03 16:47:37
 * @LastEditors: lyx
 * @LastEditTime: 2024-06-4 12:51:41
 * @FilePath: /dbrank_b/src/routes/visualChart/P27/index.js
 * @Description: p27
 */
import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './index.css';
import Stage from '../components/Stage';
import setChart from './chart';
import Chart from '../components/Chart';
import { Title24 } from '../components/Titles';
import TooltipDrawer from '../components/TooltipDrawer';
import Form from './Form';
import DBTable from '../components/DBTable';
import { object } from 'prop-types';
import { map } from 'lodash';


class P27 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chartTitle: [],
      chartList: [],
      tableList: [],
      tableColumns: [],
      tableColorList: [],
      mySize: {  // 模版大小
        width: 510, 
        height: 680 
      },
      padding: '0 0'
    }
  }
  getColor = (val, index, i, maxArr, dataList,tableCount) => {
    if (i == 0 || index == 0) {
      return '#000'
    }
    // console.log("tableCount:",tableCount);
    // console.log("index:", index); // 行
    // console.log("i:", i);         // 列
    // console.log(maxArr);
    // console.log("dataList", dataList);
    // if(maxArr[index-1]+ '%' === dataList[index][val.dataIndex]){
    // console.log("maxArr[index-1]当前第"+ index +"行的最大值",(maxArr[index-1] + '%') ,"dataList[index][val.dataIndex]当前正在渲染的数据", (dataList[index][val.dataIndex]+''));     // 当前正在渲染的数据   
    // console.log(maxArr[index-1] + '%' == (dataList[index][val.dataIndex]+''));
    // }
    // console.log("maxArrTop[index-1]当前行的最大值", maxArrTop[index-1]+ '%'); // 取出当前行的最大值
    // console.log("dataList[index][i]当前正在渲染的数据", dataList[index][val.dataIndex]);     // 当前正在渲染的数据   
    // console.log("--------------");

    return maxArr[index-1] + '%' == dataList[index][val.dataIndex].replace('\r','') ? "red" : "#000"
  }

  tBodyBgColor = (index) => {
    const { tableColorList } = this.state;

    if (index === 0) {
      return tableColorList[0];
    } else {
      return index % 2 === 1 ? '#f2f2f2' : '#d9d9d9';

    }
  }


  // 获取数据中最大值的下标,放在数组中，返回每组数组的最大值
  getMaxIndex = (tableList) => {
    let newList = JSON.parse(JSON.stringify(tableList));
    newList && newList.shift();
    // console.log(newList)
    let maxArr = []
    newList.length && newList.forEach((ele) => {
      let ii = 0;
      let maxVal = -1
      Object.keys(ele).forEach(key => {
        let val = ele[key]
        if (key !== 'key_0') {
          if (ii === 0) {
            maxVal = parseFloat(val);
          } else {
            maxVal = Math.max(parseFloat(val), maxVal)
          }
          ii += 1;
        }
      });
      maxArr.push(maxVal)
    })

    // if (newList && newList.length > 0) {
    //   maxValIndex = Object.values(newList).indexOf(maxVal + '%')
    // }
    return maxArr
  }

  fillColor = (tableColumns, tableColorList, maxArr, dataList, tableCount) => {
    const border = `1px solid #fff`

    return tableColumns.map((item, i) => {
      return {
        ...item,
        style: {
          ...item.style,
          height: 18,
          fontSize: 10,
          textAlign: 'center',
          fontWeight: 'bolder',
          color: '#000',
          background: tableColorList[0],
          borderTop: border,
          borderRight: border,
        },
        colStyle: (val, index) => ({
          ...item.colStyle,
          height: 15,
          fontSize: index === 0 ? '9' : '8',
          textAlign: 'center',
          fontWeight: index === 0 ? 'bold' : 'normal',
          color: this.getColor(val, index, i, maxArr, dataList,tableCount),
          // background: '#fff',
          borderRight: border,
          borderTop: border,
          background: this.tBodyBgColor(index)
          // background: index % 2 === 1 ? (tableColorList[1] || '#d9d9d9') : (tableColorList[2] || '#f2f2f2'),
        })
      }

    })
  }

  groupArray(array, groupSize) {
    let groups = [];
    for (let i = 0; i < array.length; i += groupSize) {
      groups.push(array.slice(i, i + groupSize));
    }
    return groups;
  }



  render() {
    const { chartTitle, chartList, tableList, tableColumns, tableColorList, mySize } = this.state;

    // console.log('chartTitle', chartTitle)
    let tableListTop = []
    let tableListBottom = []
    for (let index = 0; index < tableList.length; index++) {
      const element = tableList[index];
      let topObj = {}
      let bottomObj = {}
      let keys = Object.keys(element)
      for (let i = 0; i < keys.length; i++) {
        if (i == 0) {
          topObj[keys[i]] = element[keys[i]]
          bottomObj[keys[i]] = element[keys[i]]
        } else {
          if (i < 11) {
            topObj[keys[i]] = element[keys[i]]
          } else {
            bottomObj[keys[i]] = element[keys[i]]
          }
        }
      }
      tableListTop.push(topObj)
      tableListBottom.push(bottomObj)
    }
    // console.log("tableList:",tableList);
    // let maxArrTop = this.getMaxIndex(tableListTop);
    // console.log('maxArrTop:', maxArrTop)
    // let maxArrBottom = this.getMaxIndex(tableListBottom);
    // console.log('maxArrBottom:', maxArrBottom)
    let maxArr = this.getMaxIndex(tableList);
    // console.log('maxArr:', maxArr)
    // let maxArrBottom = this.getMaxIndex(tableList);
    // console.log('maxArrBottom:', maxArrBottom)

    let tableColumnsTop = []
    let tableColumnsBottom = []
    for (let j = 0; j < tableColumns.length; j++) {
      const obj = tableColumns[j];
      if (j == 0) {
        tableColumnsTop[j] = obj
        tableColumnsBottom[j] = obj
      } else {
        if (j < 11) {
          tableColumnsTop[j] = obj
        } else {
          tableColumnsBottom[j - 10] = obj
        }
      }
    }

    return (
      <Stage size={mySize} padding={this.state.padding}>
        <div className={s.box}>
          <Title24 pageNumber="1.5">汽车厂商用户心智榜TOP20</Title24>
          <div className={s.content} >
            <div className={s.desBox} style={{ paddingBottom: 4 }}>
              <div contentEditable className={s.des}>
                2023年，汽车厂商用户心智榜前三：比亚迪、特斯拉、赛力斯。
              </div>
              <div contentEditable className={s.des}>
                比亚迪因“全球首创800V充电技术”“第500万辆新能源汽车下线”等事件收获大量数字品牌价值，继续蝉联榜首；特斯拉“降价”“召回”等一系列事件引发大量关注、全年褒贬不一，获得用户心智榜中内容传播度、用户参与度、传播引爆度最高值；借助华为“造车”的热度，赛力斯的行业内心智占有率显著提升。
              </div>
              <div contentEditable className={s.des}>
                2小米汽车未售先火，广受行业内外人士关注，在用户心智榜中排名第十二。
              </div>
            </div>

            <div className={s.uiWrapper}>
              <div className={s.wrapper_box1}>
                <div className={s.chartWrapper}>
                  <TooltipDrawer
                    style={{ width: '100%', height: '100%' }}
                    formContent={<Form onChange={values => this.setState({ ...values })} />}>
                    <Chart options={setChart({
                      title: chartTitle.splice(0,10),
                      list: this.groupArray(chartList, 10)[0],
                      color: tableColorList,
                      chartTitleText: "汽车厂商用户心智榜TOP1~10"
                    })} />
                  </TooltipDrawer>
                </div>
                <div className={s.tableWrapper}>
                  <TooltipDrawer formContent={<Form onChange={values => this.setState({ ...values })} />}>
                    <DBTable
                      className={s.tableBox}
                      columns={this.fillColor(tableColumnsTop, tableColorList, maxArr, tableList,1)}
                      data={tableListTop}
                    // style={{
                    //   boxShadow: 'none',
                    //   borderTop: border,
                    //   borderLeft: border,
                    // }}
                    />
                  </TooltipDrawer>
                </div>
              </div>
              <div className={s.wrapper_box2}>
                <div className={s.chartWrapper2}>
                  <TooltipDrawer
                    style={{ width: '100%', height: '100%' }}
                    formContent={<Form onChange={values => this.setState({ ...values })} />}>
                    <Chart options={setChart({
                      title: chartTitle.splice(-10),
                      list: this.groupArray(chartList, 10)[1],
                      color: tableColorList,
                      chartTitleText: "汽车厂商用户心智榜TOP11~20"
                    })} />
                  </TooltipDrawer>
                </div>
                <div className={s.tableWrapper}>
                  <TooltipDrawer formContent={<Form onChange={values => this.setState({ ...values })} />}>
                    <DBTable
                      className={s.tableBox}
                      columns={this.fillColor(tableColumnsBottom, tableColorList, maxArr, tableList,2)}
                      data={tableListBottom}
                    // style={{
                    //   boxShadow: 'none',
                    //   borderTop: border,
                    //   borderLeft: border,
                    // }}
                    />
                  </TooltipDrawer>
                </div>
              </div>
              {/* <div className={s.chartWrapper}>
                <TooltipDrawer
                  style={{ width: '100%', height: '100%' }}
                  formContent={<Form onChange={values => this.setState({ ...values })} />}>
                  <Chart options={setChart({
                    label: chartTitle,
                    list: chartList,
                    color: tableColorList
                  })} />
                </TooltipDrawer>
              </div> */}
            </div>
          </div>
        </div>

      </Stage>
    );
  }
}

export default withStyles(s)(P27);



// WEBPACK FOOTER //
// src/routes/visualChart/P27/index.js